<script setup lang="ts">
import { computed } from "vue";
import { t } from "@/services/i18n";

const props = defineProps({
    rating: {
        type: Number,
        default: 0,
    },
    votes: {
        type: Number,
        default: 0,
    },
    isNew: {
        type: Boolean,
        default: false,
    },
});

const ratingToOneDecimal = computed(() => {
    return Math.round(props.rating * 10) / 10 || 0;
});
</script>
<template>
    <div class="[ c-card__rating ]">
        <div v-if="votes > 0 || isNew">
            <span class="[ c-card__rating-icon ]">
                <span class="[ c-icon ] [ icon-star--filled ]"></span>
            </span>
            <span v-if="rating > 0 && votes > 0">
                <span class="[ c-card__rating-number ]">
                    {{ ratingToOneDecimal }}
                </span>
                <span class="[ c-card__rating-amount ]">({{ votes }})</span>
            </span>
            <span class="[ c-card__rating-number ]" v-else-if="isNew">
                {{ t("new") }}
            </span>
        </div>
    </div>
</template>
